export enum ProductModule {
  FAMOUS_INTEGRATION = "famous-integration",
  ORDERFUL_EDI = "orderful-edi",
  ORDER_MANAGEMENT = "order-management",
  REBATES = "rebates",
  PROCUREMENT = "procurement",
  SHIP_AND_DEBIT = "ship-and-debit",
  AP_INVOICING = "ap-invoicing",
  ORACLE_EBS_INTEGRATION = "oracle-ebs-integration",
  PROCUREMENT_DEMO = "procurement-demo",
}

// Note: changes to these values can break things in polymorphic relationships. Please be careful.
export enum AIWorkflow {
  EMAIL_SO_INGESTION = "EMAIL_SO_INGESTION",
  PRICE_SHEET_INGESTION = "PRICE_SHEET_INGESTION",
  AP_INVOICE_INGESTION = "AP_INVOICE_INGESTION",
}

export const WorkflowStepMapping = {
  [AIWorkflow.EMAIL_SO_INGESTION]: ["EXTRACT_SALES_ORDER"],
  [AIWorkflow.PRICE_SHEET_INGESTION]: ["PRICE_SHEET_INGESTION"],
  [AIWorkflow.AP_INVOICE_INGESTION]: ["AP_INVOICE_INGESTION"],
} as const satisfies Record<AIWorkflow, string[]>;

export type WorkflowStep =
  (typeof WorkflowStepMapping)[keyof typeof WorkflowStepMapping][number];

export const WorkflowStepValues = Object.values(WorkflowStepMapping).flat();

export type RegisteredEmailHeaderOption = "to" | "cc";

export type RegisteredEmailDomain = {
  header: RegisteredEmailHeaderOption;
  domain: string;
};

export type AIWorkflowConfig = {
  registeredEmailDomains?: RegisteredEmailDomain[];
};

// Type for module configuration objects
export interface ModuleConfig {
  emailWorkflows?: {
    [key in AIWorkflow]?: AIWorkflowConfig;
  };
  ap?: {
    invoiceLineItemPurchaseMatching?: string[][]; // Array of arrays of SystemEntity for AND/OR logic
    // TODO: Add SystemEntity.GOODS_RECEIPT_LINE_ITEM for 3-way matching
    paymentScheduling?: {
      mode: "immediate" | "payRun" | "latestDate";
      cron?: string; // for payRun mode
      immediacy?: "asap" | "latest"; // for payRun mode
      rounding?: "up" | "down" | "nearest"; // for payRun mode
      timezone?: string; // for payRun mode
      daysBeforeDue?: number; // for latestDate mode
    };
  };
  oracleEbs?: {
    /** URL of the Oracle Query Server (e.g., http://localhost:3030) */
    queryServerUrl?: string;
    /** Default organization code when no planner mapping is found */
    defaultOrgCode?: string;
    /** Map of planner codes to Oracle EBS organization codes */
    plannerOrgCodeMap?: Record<string, string>;
    /** Default price list name for price lookups (e.g., "EEME&A DISTRIBUTOR") */
    defaultPriceListName?: string;
    /** Default Oracle EBS organization ID for price lookups (numeric, e.g., 95) */
    defaultOracleOrgId?: number;
  };
}

// Type for organization module configuration
export interface OrganizationModuleConfig {
  id: string;
  organizationId: string;
  module: ProductModule;
  enabled: boolean;
  config: ModuleConfig;
  createdAt: Date;
  updatedAt: Date;
}
